const state = function() {
  return {
    apiManager: {},

    items: [],
    page: 0,
    pageCount: 0,
    perPage: 0,
    total: 0,
    hasMorePages: false,
    isLoaded: false,
    isChanged: false,
    timezones: null,
    validationError: null,
  };
};

export default state;


// WEBPACK FOOTER //
// ./src/modules/user/vuex/state.js